import H from 'constants/httpMethod.const';

const ALLOWED_METHODS = Object.freeze({
  GET: H.get,
  get: H.get,
  POST: H.post,
  post: H.post,
  PUT: H.put,
  put: H.put,
  DELETE: H.del,
  delete: H.del,
  DEL: H.del,
  del: H.del,
  PATCH: H.patch,
  patch: H.patch,
});

// noinspection JSUnusedGlobalSymbols
export default ALLOWED_METHODS;
